import React from "react";
import { Factory, PagesHero, Showroom, NewBorn } from "../components";
import { useTranslation } from "../hooks/useTranslation";

function Work() {
  const { t } = useTranslation();

  return (
    <>
      <PagesHero
        title={t("pages.work.title")}
        description={t("pages.work.description")}
        backgroundImage="/assets/images/workHero.jpg"
      />
      <Factory />
      <NewBorn />
      {/* <Showroom /> */}
    </>
  );
}

export default Work;
